// utils/enabledFeatures.ts

export enum FeaturesEnum {
    SignInWithGoogle,
    ForgotPassword,
    SexyDocuments,
    SexySpinner,
    DocumentSearching,
    DemoDocumentData,
    StubClients,
    DrawerSignOutButton,
    AdvancedDocumentCreation,
    DirectS3Uploads,
    ListingInferenceReviewPortal,
    StatementClassifier,
    ClientCreation,
    ContextPreviewInferences
}

export const enabledFeatures: { [key in FeaturesEnum]: boolean } = {
    [FeaturesEnum.SignInWithGoogle]: false,
    [FeaturesEnum.ForgotPassword]: false,
    [FeaturesEnum.SexyDocuments]: false,
    [FeaturesEnum.SexySpinner]: true,
    [FeaturesEnum.DocumentSearching]: false,
    [FeaturesEnum.DemoDocumentData]: false,
    [FeaturesEnum.StubClients]: import.meta.env.VITE_STUB_CLIENTS === "1",
    [FeaturesEnum.DrawerSignOutButton]: true,
    [FeaturesEnum.AdvancedDocumentCreation]: false,
    [FeaturesEnum.DirectS3Uploads]: import.meta.env.VITE_DIRECT_S3_UPLOADS === "1",
    [FeaturesEnum.ListingInferenceReviewPortal]: import.meta.env.VITE_LISTING_INFERENCE_REVIEW_PORTAL === "1",
    [FeaturesEnum.StatementClassifier]: import.meta.env.VITE_STATEMENT_CLASSIFIER === "1",
    [FeaturesEnum.ClientCreation]: import.meta.env.VITE_CLIENT_CREATION === "1",
    [FeaturesEnum.ContextPreviewInferences]: import.meta.env.VITE_CONTEXT_PREVIEW_INFERENCES === "1"
}
